import { useState, useEffect } from 'react';

// Developer bypass key for rate limiting
const DEV_BYPASS_KEY = 'slens_dev_betatester_2025';

/**
 * Hook to enable admin/debug mode in production
 * Secret sequence: ↑ ↑ ↓ ↓ Enter
 *
 * This mode reveals:
 * - Provider selection
 * - Model configuration
 * - Debug panels
 * - Advanced settings
 * - Bypasses rate limiting (developer mode)
 */
export const useAdminMode = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let sequence: string[] = [];
    const SECRET = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'Enter'];
    let timeout: NodeJS.Timeout;

    const handler = (e: KeyboardEvent) => {
      // Clear existing timeout
      clearTimeout(timeout);

      // Add key to sequence
      sequence.push(e.key);

      // Keep only the last N keys (sliding window)
      if (sequence.length > SECRET.length) {
        sequence = sequence.slice(-SECRET.length);
      }

      // Check if sequence matches
      if (sequence.join('') === SECRET.join('')) {
        setIsAdmin(true);
        sequence = [];

        // Store developer bypass key in localStorage
        localStorage.setItem('devBypassKey', DEV_BYPASS_KEY);

        console.log('🔓 Admin mode activated');
        console.log('🔓 Rate limiting bypassed for this session');
      }

      // Reset sequence after 2s of inactivity
      timeout = setTimeout(() => {
        sequence = [];
      }, 2000);
    };

    window.addEventListener('keydown', handler);

    return () => {
      window.removeEventListener('keydown', handler);
      clearTimeout(timeout);
    };
  }, []);

  return isAdmin;
};

/**
 * Get developer bypass key from localStorage
 * Used by API services to bypass rate limiting
 */
export const getDevBypassKey = (): string | null => {
  return localStorage.getItem('devBypassKey');
};
